import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NarikCustomValidatorsModule } from '@narik/custom-validators';
import { ClipboardModule } from 'ngx-clipboard';
import { AutofocusDirective } from '../components/autofocus/autofocus.component';
import { BlockableComponent } from '../components/blockable/blockable.component';
import { CustomFieldsetModule } from '../components/custom-fieldset/custom-fieldset.module';
import { UppercaseDirective } from '../components/uppercase/uppercase.directive';
import { CustomDrawerModule } from './custom-drawer/custom-drawer.module';
import { HorizontalScrollModule } from './horizontal-scroll/horizontal-scroll.module';
import { LazyLoaderModule } from './lazy-loader/lazy-loader.module';
import { PrimeModule } from './modules/prime.module';
import { SecurityModule } from './security/security-module';



@NgModule({
    imports: [
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        PrimeModule,
        ClipboardModule,
        NarikCustomValidatorsModule,
        SecurityModule,
        LazyLoaderModule,
        CustomFieldsetModule,
        HorizontalScrollModule,
        CustomDrawerModule,
    ],
    exports: [
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        ClipboardModule,
        PrimeModule,
        NarikCustomValidatorsModule,
        BlockableComponent,
        LazyLoaderModule,
        CustomFieldsetModule,
        HorizontalScrollModule,
        AutofocusDirective,
        CustomDrawerModule,
    ],
    declarations: [
        BlockableComponent,
        AutofocusDirective,
        UppercaseDirective
    ]
})
export class AppSharedModule {

}
